export default "<div name=\"termly-embed\" data-id=\"924ef2c3-b0aa-41de-af43-0589878e7a76\" data-type=\"iframe\"></div>"